import React from "react";
import { cn } from "./cn";
import { FieldLabel } from "./FieldLabel";
import { LockIcon } from "../../../assets/ui/icons";

/* A value carried in from elsewhere — the company's country, the emirate chosen on the licence step — shown for confirmation but not editable here. */
export const ReadOnlyField = ({
  label,
  value,
  prefix,
  /* Forwarded to FieldLabel, as on SelectField. */
  labelVariant,
  className = "",
}) => (
  <div className={className}>
    <FieldLabel variant={labelVariant}>{label}</FieldLabel>
    <div className="mt-1.5 flex items-center gap-2 rounded-[var(--radius-field)] border border-[var(--field-inset-border)] bg-[var(--field-inset)] px-3.5 py-[11px] text-[14px] text-[var(--ink-2)] font-sans">
      {prefix && (
        <span aria-hidden="true" className="shrink-0 text-[16px] leading-none">
          {prefix}
        </span>
      )}
      <span className="min-w-0 flex-1 truncate">{value}</span>
      <LockIcon className="shrink-0 text-[var(--muted-2)]" />
    </div>
  </div>
);

export default ReadOnlyField;
